import React from "react";
import CurrentOpeningFormPage from "../components/career/CurrentOpeningFormPage";

const CareerCurrentOpeningEdit = () => <CurrentOpeningFormPage mode="edit" />;

export default CareerCurrentOpeningEdit;
